// src/components/FloatingNotice.js
import React, { useState, useEffect } from "react";

const colors = [
  "bg-blue-500", "bg-green-500", "bg-purple-500",
  "bg-red-500", "bg-yellow-500", "bg-pink-500",
  "bg-indigo-500", "bg-teal-500"
];

const directions = ["left", "center", "right"];

const getRandomPosition = (direction) => {
  const randX = Math.floor(Math.random() * 60) + 20;
  switch (direction) {
    case "left": return { top: "10px", left: `${randX}%` };
    case "right": return { top: "10px", right: `${randX}%` };
    case "center": return { top: "10px", left: "50%", transform: "translateX(-50%)" };
    default: return { top: "10px", left: "50%", transform: "translateX(-50%)" };
  }
};

// ✅ SIMPLIFIED: shows a single message once, holds it steady for
// `duration` ms, then disappears for good. No more looping/cycling back
// to the same message — that was for an older feature that's no longer
// in use, and it was the actual cause of the "shaking" behavior, since
// a single message would loop back to itself repeatedly.
const FloatingNotice = ({ message, duration = 7000 }) => {
  const [style, setStyle] = useState({});
  const [color, setColor] = useState("");
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!message) return;

    const dir = directions[Math.floor(Math.random() * directions.length)];
    setStyle(getRandomPosition(dir));
    setColor(colors[Math.floor(Math.random() * colors.length)]);
    setVisible(true);

    const hideTimeout = setTimeout(() => {
      setVisible(false);
    }, duration);

    return () => clearTimeout(hideTimeout);
  }, [message, duration]);

  if (!message) return null;

  return (
    <div
      className={`
        fixed px-3 py-2 rounded-lg shadow-lg text-white font-medium text-xs sm:text-sm
        transition-all duration-1000 ease-in-out transform
        ${color}
        ${visible ? "opacity-100 scale-100 rotate-0" : "opacity-0 scale-90 rotate-3"}
      `}
      style={{
        ...style,
        zIndex: 9999,
        pointerEvents: "none",
      }}
    >
      {message}
    </div>
  );
};

export default FloatingNotice;
